import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromActionBars from '../reducers/action-bars.reducer';
import { ActionBar } from '../../models';

export const getActionBarState = createSelector(fromFeature.getContentState, (state: fromFeature.ContentState) => state.actionBars);

export const getActionBarEntities = createSelector(getActionBarState, fromActionBars.getActionBarsEntities);

export const getAllActionBars = createSelector(getActionBarEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]);
});
export const getActionBarsLoaded = createSelector(getActionBarState, fromActionBars.getActionBarsLoaded);
export const getActionBarsLoading = createSelector(getActionBarState, fromActionBars.getActionBarsLoading);

export const getActiveActionBar = createSelector(getAllActionBars, (bars): ActionBar => {
  return bars[0];
});
